/**
 * API service for the Roster and Rates page
 */
import { apiRequest } from "../../services/apiMiddleware";
import { API_GATEWAY_PROCESS_NAME } from "../../utils/constants";
import { GetRatesAndRosterRequest, GetRatesAndRosterResponse } from "./model";
import {
  GET_RATES_AND_ROSTER_API,
  logOperationalMetric,
  MetricType,
  RCC_SHIFT_PLAN_ROSTER_AND_RATES_TAB,
} from "../../utils/metric-utils";

/**
 * Verify roster data
 * @returns Promise indicating success
 */
export const verifyRoster = async (): Promise<boolean> => {
  // In a real implementation, this would be an API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, 300);
  });
};

/**
 * Get rates and roster data from the API
 * @param warehouseId The warehouse identifier
 * @param date The date in YYYY-MM-DD format
 * @param shift The shift identifier (DAY, NIGHT)
 * @param planId The plan identifier
 * @param department Optional department identifier
 * @returns Promise with GetRatesAndRosterResponse
 */
export const getRatesAndRoster = async (
  warehouseId: string,
  date: string,
  shift: string,
  planId: string,
  department?: string
): Promise<GetRatesAndRosterResponse> => {
  const startTime = Date.now();
  try {
    // Construct request body
    const requestBody: GetRatesAndRosterRequest = {
      warehouseId,
      date,
      shift,
      planId,
      ...(department && { department }),
    };

    const requestPayload = {
      resourcePath: "/getRatesAndRoster",
      httpMethod: "post",
      processName: API_GATEWAY_PROCESS_NAME,
      requestBody,
    };

    const response = await apiRequest(requestPayload);

    console.log("Rates and roster data fetched successfully:", response);

    logOperationalMetric(startTime, warehouseId, RCC_SHIFT_PLAN_ROSTER_AND_RATES_TAB, GET_RATES_AND_ROSTER_API, MetricType.SUCCESS);

    return {
      rosterData: response.data.rosterData,
      ratesData: response.data.ratesData,
      planStatus: response.data.planStatus,
    };
  } catch (error: any) {
    console.error("Error fetching rates and roster data:", error);
    logOperationalMetric(startTime, warehouseId, RCC_SHIFT_PLAN_ROSTER_AND_RATES_TAB, GET_RATES_AND_ROSTER_API, MetricType.FAILED, error);
    throw error;
  }
};
